import type { ContentServiceV1 } from '@oneaudi/content-service';
import { PropsWithChildren, RefObject } from 'react';
import { RenderMode } from '@oneaudi/render-mode-service';
import { I18nMessages, Content, TRIGGERID, SUBMENUID } from '../ContentType';
import { CustomTheme } from '../../@types/theme';

export enum AppTheme {
  LIGHT = 'light',
  DARK = 'dark',
}
export interface ContextProviderProps extends PropsWithChildren {
  readonly contentService: ContentServiceV1;
}

export interface VtpData {
  readonly newCarsText: string;
  readonly usedCarsText: string;
  readonly usedCarsAmount: number;
  readonly newCarsAmount: number;
  readonly newCarsUrl: string;
  readonly usedCarsUrl: string;
  readonly vtpLabel: string;
}
export interface ContextState {
  readonly theme: CustomTheme;
  readonly renderMode: RenderMode;
  readonly content: Content;
  readonly vtpData: VtpData;
  readonly headline: string;
  readonly triggerId: TRIGGERID;
  readonly setTriggerId: (id: TRIGGERID) => void;
  readonly submenuId: SUBMENUID;
  readonly setSubmenuId: (id: SUBMENUID) => void;
  readonly stickymode: boolean;
  readonly hasLinks: boolean;
  readonly hasCta: boolean;
  readonly showSubmenu: boolean;
  readonly toggleShowSubmenu: () => void;
  readonly renderPrimaryButton: boolean;
  readonly renderSecondaryButton: boolean;
  readonly renderVtpButtons: boolean;
  readonly i18nMessages: I18nMessages;
  readonly isPopOverOpen: boolean;
  readonly setPopOverState: (popOverState: boolean) => void;
  readonly submenuDesktopRef: RefObject<HTMLDivElement>;
  readonly submenuMobileRef: RefObject<HTMLDivElement>;
  readonly submenuTriggerRef: RefObject<HTMLButtonElement>;
  readonly linkCount: number;
  readonly ctaCount: number;
}
